import { render, staticRenderFns } from "./kpisnew.vue?vue&type=template&id=3ac24cc5&lang=pug"
import script from "./kpisnew.vue?vue&type=script&lang=js"
export * from "./kpisnew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports